import React from 'react';
import dayjs from 'dayjs';

// Days until trial_ends_at, or null if the org isn't an active trial.
// Shared by the homepage banner and the sidebar chip so they can't disagree.
export function trialDaysLeft(org) {
  if (!org || org.billing_status !== 'Free Trial') {
    return null;
  }
  // an active trial with a missing or unparseable end date counts as already
  // ended rather than hiding the banner — nothing to count down from
  if (!org.trial_ends_at) {
    return 0;
  }
  const trialEnd = dayjs(org.trial_ends_at);
  if (!trialEnd.isValid()) {
    return 0;
  }
  return Math.ceil(trialEnd.diff(dayjs(), 'day', true));
}

// escalation: calm for most of the trial, red inside the final week. The
// "ended" text state is a failsafe — the backend flips orgs to Inactive at
// trial end, so customers should normally never see it. Shared by the banner
// and the sidebar chip.
export function trialTierColors(daysLeft) {
  if (daysLeft <= 7) return 'bg-red-50 border-red-100 text-red-600';
  return 'bg-white border-surface-200 text-surface-700';
}

function TrialBanner(props) {
  const { org } = props;
  const daysLeft = trialDaysLeft(org);
  if (daysLeft === null) return null;

  const text = daysLeft <= 0
    ? "Your free trial has ended. We'll be in touch about billing."
    : `You have ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left in your free trial.`;
  return (
    <div className={`mb-4 text-sm border rounded-md px-3 py-2 ${trialTierColors(daysLeft)}`}>
      {text}
    </div>
  );
}

export default TrialBanner;
